import { useMemo } from "react";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { TicketHebType } from "@models/types";

/**
 * Loads account structure fields for search vs browse tables by Hebrew account type key.
 */
export function useAccountTypeStructures(accountType: TicketHebType) {
  const { data: structure } = useGetAccountStructureQuery(accountType);

  const searchStructure = useMemo(
    () => structure?.filter((field) => field.show_search),
    [structure],
  );

  const tableStructure = useMemo(
    () => structure?.filter((field) => field.show_browse),
    [structure],
  );

  return { searchStructure, tableStructure };
}
